import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Wand2 } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";

const NewHereSection = () => {
  const { t } = useTranslation();

  return (
    <section className="home-paper pt-6 pb-16 md:pb-24 relative overflow-hidden">
      <div className="px-4 md:px-8 relative z-10">
        <div className="max-w-6xl mx-auto border-t border-foreground/15 pt-8">
          <div className="relative overflow-hidden rounded-2xl bg-card border border-border shadow-[var(--shadow-editorial)] p-7 md:p-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <span aria-hidden="true" className="absolute -right-5 -top-8 text-[9rem] leading-none text-foreground/5 home-display italic">?</span>
            <h2 className="home-display relative text-4xl md:text-5xl font-extrabold text-foreground">
              {t.home.newHere?.title || "New here?"}
            </h2>
            <Button
              asChild
              size="lg"
              className="relative bg-foreground text-background hover:bg-foreground/90 rounded-xl px-7 py-6 text-sm font-semibold shadow-[var(--shadow-ink-soft)] transition-all hover:-translate-y-0.5"
            >
              <Link to="/sampler">
                <Wand2 size={20} className="mr-2" />
                {t.sampler.showMeBtn}
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewHereSection;
